<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="紧急程度" required>
				<c-radio-group name="urgency_level" :options="orderUrgencyDic"></c-radio-group>
			</c-form-item>
			<c-form-item label="关联售后工单" required>
				<c-select v-model="workOrderId" ref="orderSelect" name="order_id" async :disabled="!!source" :clear="false" @search="searchOrder">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								`${data.data.customer_name||'-'} | ${data.data.create_date}`
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="AFTERSALE_ORDER" :id="workOrderId"></info-card>
			</c-form-item>
			<c-form-item label="招工类型" required>
				<c-select name="recruit_type" :options="recruitTypeDic"></c-select>
			</c-form-item>
			<c-form-item label="招工人数" required>
				<c-input type="stepper" name="recruit_count" :range="[1,Infinity]" append-text="人"></c-input>
			</c-form-item>
			<c-form-item label="上班天数" required>
				<c-input type="stepper" name="work_days" :range="[1,Infinity]" append-text="天"></c-input>
			</c-form-item>
			<c-form-item label="所需费用" required>
				<c-input type="stepper" name="required_fee" :range="[0.01,Infinity]" decimal="2" append-text="元"></c-input>
			</c-form-item>
			<c-form-item label="人员到岗时间" required>
				<c-datetime type="date" name="arrival_time"></c-datetime>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>

			<!-- <cut-line></cut-line> -->

			<doc-flow ref="flow" flow="2"></doc-flow>
		</c-form>

		<template #button>
			<c-button size="form" @click="submitHandle(-1)">暂存</c-button>
			<c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String,
			source: String
		},

		data() {
			return {
				workOrderId: '',
			}
		},

		computed: {
			...mapState(['orderUrgencyDic', 'recruitTypeDic'])
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/outsource/recruit/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo}) => {
						this.$refs.form.set(detailInfo);
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.order_id
						}]);
					}
				})
			} else if (this.source) {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.source
					},
					success: ({detailInfo}) => {
						this.$refs.form.set({
							urgency_level: 1
						});
						this.$refs.orderSelect.setValueData([{
							name: detailInfo.order_number,
							value: detailInfo.id
						}]);
					}
				});
			} else {
				this.$refs.form.set({
					urgency_level: 1
				});
			}
		},

		methods: {
			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_ORDER',
                        is_charge: 1,
                        status:[2,3,4],//外协招工，只能选择未完成的工单
                        keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.order_number,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			submitHandle(state) {
				this.$refs.form.submit({
					url: this.id ? '/outsource/recruit/edit' : '/outsource/recruit/add',
					rule: {
						urgency_level: '请选择紧急程度',
						order_id: '请选择关联工单',
						recruit_type: '请选择招工类型',
						recruit_count: '请填写招工人数',
						work_days: '请填写上班天数',
						required_fee: '请填写所需费用',
						arrival_time: '请填写到岗时间'
					},
					dataFormatter: data => {
						data.id = this.id;
						data.status = state;
						return data;
					},
					success: (data, res) => {
						this.$refs.flow.apply(state, res.transaction, () => {
							this.$message({
								message: '提交成功',
								mask: true
							});
							setTimeout(() => {
								if (this.id) {
									this.mp.navigateBack();
								} else {
									this.mp.redirectWeb('/aftersales/outsource/detail', {id: res.detailInfo.id});
								}
							}, 1000);
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>